<template>
  <div>
    <div class="container" style="">
      <nav aria-label="breadcrumb" style="margin-top: 15px;">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><router-link to="/" name="Inicio">Inicio</router-link></li>
          <li class="breadcrumb-item active" aria-current="page">Ajustes</li>
        </ol>
      </nav>
      <div class="row" style="margin-top:50px;margin-bottom:20px;">
        <div class="col-md-10">
          <h3>Alterar tabela</h3>
          
        </div>
        <div class="col-md-2 d-flex align-items-center justify-content-end">
          <div class="btn btn-dark " @click="Exportar">Exportar</div>
        </div>
      </div>
      <table class="table table-striped">
        <thead>
          <tr>
            <th scope="col">Tabela</th>
            <th scope="col">Molde</th>
            <th scope="col">Torax</th>
            <th scope="col">Cintura</th>
            <th scope="col">Quadril</th>
            <th scope="col">Gancho</th>
            <th scope="col">Var Min largura</th>
            <th scope="col">Var Max largura</th>
            <th scope="col">Var Min gancho</th>
            <th scope="col">Var Max gancho</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in tabela">
            <td><textarea class="form-control" type="text" v-model="item.tabela"></textarea></td>
            <td><textarea class="form-control" type="text" v-model="item.molde"></textarea></td>
            <td><input class="form-control" style="max-width: 53px" type="text" v-model.number="item.torax" ></td>
            <td><input class="form-control" style="max-width: 53px" type="text" v-model.number="item.cintura" ></td>
            <td><input class="form-control" style="max-width: 53px" type="text" v-model.number="item.quadril" ></td>
            <td><input class="form-control" style="max-width: 53px" type="text" v-model.number="item.gancho" ></td>
            <td><input class="form-control" style="max-width: 53px" type="text" v-model.number="item.variacao_minima_largura" ></td>
            <td><input class="form-control" style="max-width: 53px" type="text" v-model.number="item.variacao_maxima_largura" ></td>
            <td><input class="form-control" style="max-width: 53px" type="text" v-model.number="item.variacao_minima_gancho" ></td>
            <td><input class="form-control" style="max-width: 53px" type="text" v-model.number="item.variacao_maxima_gancho" ></td>
          </tr>
        </tbody>
      </table>
      
    </div>
  </div>
</template>

<script>
export default {
  name: 'Ajustes',
  data () {
    return {
      tabela: JSON.parse(JSON.stringify(TabelaMoldes))
    }
  },
  methods:{
    Salvar(){

    },
    Cancelar(){
      this.tabela = JSON.parse(JSON.stringify(TabelaMoldes));
    },
    Exportar(){
     var jsContent = "data:text/plain;charset=utf-8,const TabelaMoldes =";
     jsContent +=JSON.stringify(this.tabela)

     var encodedUri = encodeURI(jsContent);
     var link = document.createElement("a");
     link.setAttribute("href", encodedUri);
     link.setAttribute("download", "tabela.txt");
     document.body.appendChild(link); // Required for FF
     link.click();
     // console.log(jsContent);
   }
 }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a{
  color: #e59042
}
</style>



// WEBPACK FOOTER //
// src/components/ajustes.vue